import "./styles.css";
// import Button from "@kaizen-ui/button";

// import { useNavigate } from "react-router-dom";
export default function UnAuthorized() {
  // const navigate = useNavigate();
  return (
    <div className="unauthorized-page-container">
      <div className="unauthorized-page-content">
        <div
          style={{
            dispplay: "flex",
            justifyContent: "space-around",
            flexDirection: "row",
            marginBottom: "20px",
          }}
        >
          <p style={{ fontSize: "40px", margin: "0px", fontWeight: "bold" }}>
            <span style={{ fontSize: "40px", color: "red" }}>401</span>{" "}
            UNAUTHORIZED
          </p>
          <p style={{ marginTop: "0px" }}>
            You are not authorized to view this page!
          </p>
        </div>

        {/* <Button
          key="btncreateresponse"
          style={{ width: "200px" }}
          onClick={() => {
            navigate("/dashboard");
          }}
        >
          Go to DashBoard
        </Button> */}
      </div>
    </div>
  );
}
